<template>
  <b-modal
    ref="profile-modal"
    no-close-on-backdrop
    hide-footer
    title="แก้ไขข้อมูลส่วนตัว"
    ok-variant="success"
    ok-title="แก้ไขข้อมูลส่วนตัว"
    cancel-title="ยกเลิก"
    footer-class="justify-content-between"
    @show="resetModal"
    @hidden="resetModal"
    class="position-relative"
  >
    <form
      ref="form"
      @submit.stop.prevent="handleSubmit"
    >

      <b-form-group
        label="ชื่อผู้ใช้"
      >
        <b-form-input
          v-model="input.username"
          type="text"
          disabled
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="ชื่อ"
      >
        <b-form-input
          v-model="input.firstName"
          type="text"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="นามสกุล"
      >
        <b-form-input
          v-model="input.lastName"
          type="text"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="โทรศัพท์"
      >
        <b-form-input
          v-model="input.tel"
          type="text"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="Line ID"
      >
        <b-form-input
          v-model="input.lineId"
          type="text"
        ></b-form-input>
      </b-form-group>

      <!--<b-button type="submit" variant="primary" block pill :disabled="isProcess">{{isProcess ? 'กำลังบันทึกข้อมูล...' : 'แก้ไขข้อมูล'}}</b-button>-->
      <div class="d-flex justify-content-end mt-3 pt-3">
        <b-button variant="link" size="sm" class="text-secondary mr-3" @click="hideModal">ยกเลิก</b-button>
        <b-button type="submit" variant="primary" size="sm" :disabled="isProcess">{{isProcess ? 'กำลังบันทึก...' : 'บันทึก'}}</b-button>
      </div>
    </form>

    <loading
      :active="isProcess"
      :can-cancel="false"
      :is-full-page="false"
      background-color="#EBEDEF"
      :height="30"
      :width="30"
      color="#007bff"
    />
  </b-modal>
</template>
<script>
import ManageAccountService from "@/services/ManageAccountService"
import Swal from 'sweetalert2'
import cAlert from '@/helpers/alert'

export default {
  name: 'EditProfileModal',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      defalut: {
        _id: null,
        username: null,
        firstName: null,
        lastName: null,
        tel: null,
        lineId: null
      }
    }
  },
  data() {
    return {
      isProcess: false,
      needReload: false,
      input: JSON.parse(JSON.stringify(this.data))
    }
  },
  watch: {
    isShow() {
      if(this.isShow){
        this.showModal()
      }else{
        this.hideModal()
      }
    },
    data() {
      this.input = JSON.parse(JSON.stringify(this.data))
    }
  },
  methods: {
    resetModal() {
      this.isProcess = false
      this.needReload = false
      this.input = {
        _id: null,
        username: null,
        firstName: null,
        lastName: null,
        tel: null,
        lineId: null
      }
    },
    showModal() {
      this.$refs['profile-modal'].show()
    },
    hideModal() {
      this.$refs['profile-modal'].hide()
    },
    handleSubmit() {
      this.isProcess = true
      ManageAccountService.updateProfile(this.data._id, this.input)
      .then((response)=>{
        console.log(response)
        if(response.success) {
          this.needReload = true
          this.hideModal()
          this.$notify({
            type: 'success',
            title: 'สำเร็จ!',
            text: 'แก้ไขข้อมูลเสร็จเรียบร้อย',
          })
        }else{
          throw response
        }
      })
      .catch((e)=>{
        console.log(e)
        cAlert({
          ...e,
          title: 'ผิดพลาด!',
          text: e?.message || 'แก้ไขข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
          icon: 'error',
          confirmButtonText: 'OK'
        })
      })
      .finally(()=>{
        this.isProcess = false
      })
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      this.$emit('close', this.needReload)
    })
  }
}
</script>
